module.exports = require("@seddi/three/examples/jsm/utils/BufferGeometryUtils.js");